import { ComponentSettings } from "../settings/settings";

const settings = {
  permission: {},
  text: {},
  list: {},
  url: {},
  field: {},
  additionalInfo: {},
};

export const parameter: ComponentSettings<typeof settings> = settings;
